import { lazy } from 'react';
import { withSuspense } from '../../hoc/WithSuspense';

const MediaViewer = lazy(() =>
  import(
    /* webpackChunkName: "MediaViewer" */
    './BaseMediaViewer'
  ).then((module) => ({ default: module.BaseMediaViewer })),
);

export default withSuspense(MediaViewer);
